// extracted by css-extract-rspack-plugin
module.exports =  {"alert":"UnavailableAlert__alert--ownL7","officeName":"UnavailableAlert__officeName--lgZJ_"};